import { ref } from 'vue'

export interface AuthUser {
  username: string
  userType: string
  roles: string[]
}

const user = ref<AuthUser | null>(null)
const checked = ref(false)

export function useAuth() {
  async function fetchMe(): Promise<boolean> {
    try {
      const res = await fetch('/api/auth/portal/me', { credentials: 'include' })
      if (res.ok) {
        user.value = await res.json()
        checked.value = true
        return true
      }
    } catch {
      // network error — treat as unauthenticated
    }
    user.value = null
    checked.value = true
    return false
  }

  async function login(username: string, password: string, rememberMe = false): Promise<string | null> {
    const res = await fetch('/api/auth/portal/login', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password, rememberMe }),
    })

    if (res.ok) {
      await fetchMe()
      return null
    }

    if (res.status === 423) return 'Your account is locked out. Please try again later.'
    const body = await res.json().catch(() => ({}))
    return body.message ?? 'Invalid credentials.'
  }

  async function logout(): Promise<void> {
    await fetch('/api/auth/portal/logout', { method: 'POST', credentials: 'include' })
    user.value = null
    checked.value = false
  }

  return { user, checked, fetchMe, login, logout }
}
